var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('iframe',{ref:"popup",staticStyle:{"height":"100vh","width":"100vw"},attrs:{"src":_vm.$options.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }